import { apiClient } from './authService';

const appearanceService = {
  // Public: used at app startup (no auth required).
  // state = 'published' (default, what dev serves) or 'draft' (control-panel preview).
  getSettings: async (state = 'published') => {
    const res = await apiClient.get(
      state === 'draft' ? 'appearance/settings/?state=draft' : 'appearance/settings/'
    );
    return res.data;
  },

  // Admin only: save theme/branding/content/layout (JSON, no file).
  updateSettings: async (data) => {
    const res = await apiClient.patch('appearance/settings/', data);
    return res.data;
  },

  // Admin only: upload the logo file on its own (multipart).
  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo_image', file);
    const res = await apiClient.patch('appearance/settings/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
};

export default appearanceService;
